var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('b-form-select-option',{attrs:{"value":null,"disabled":_vm.$attrs.required}},[_vm._v("Select one")])]},proxy:true}])},'b-form-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }